import { adminApi } from '~/api'
import { useQuery } from '@tanstack/react-query'

export const useUserQuery = (id) =>
  useQuery({
    queryKey: ['user', id],
    queryFn: async () => {
      const { data } = await adminApi.getUser(id)
      return data.data
    }
  })
